module.exports = __webpack_public_path__ + "img/jt_express.43601aed.png";